//PRESENTATIONS page
//*******************************************************************
//*******************************************************************
//IMPORTS:
//EXTERNAL & PACKAGE
import $ from 'jquery'
import Popper from 'popper.js'
import React from 'react'
import {graphql, Link} from 'gatsby'
//COMPONENT DEPENDENCIES
import Heading from '../../components/heading'
import Navbar from '../../components/navbar'
import Footer from '../../components/footer'
import Layout from '../../components/layout'
import PageHeader from '../../components/PageHeader'
import FullWidthImage from '../../components/FullWidthImage'
import TextBlock from '../../components/textblock'
import SmallSubHeader from '../../components/SmallSubHeader'
import ContentBlock from '../../components/ContentBlock'
import Helmet from "react-helmet"
//*******************************************************************
//*******************************************************************     
const presentationsPage = ({data}) => {

    const presentations = data.presentations.edges
   
    return (
        
        <div>
                    
            
            <Helmet>
                   <title>NJCCIC Presentations</title>
                    <meta name="description" content="The NJCCIC provides a variety of free presentation on cyber security topics"/>
            </Helmet>
            <Heading/>
            
            <Navbar/>        
        
            {presentations.map(({ node: {page_title, introductory_text, image, image_alt_text, content_group, call_to_action, text, request_button} }) => (
                
                <div class="container-fluid">                    
                
                    <PageHeader elementClass="pageHeader centerText" title={page_title}/>
                    
                    <div class="container containerWidth">
                        
                        <div class="row">
                            
                            <TextBlock elementClass="standardText introPadding" text={introductory_text}/>
                            
                        </div>
                        
                    </div>
        
                    <ContentBlock testClass="testClass container containerWidth presentations" elementClass="col-12 col-lg-6 standardText blocks block2" dangerousClass="standardText blockText margin padding" headerStyles="header contentTitle" data={content_group}/>
                    
                    <div class="container containerWidth">
        
                        <TextBlock elementClass="col-12 textPadding" id='callToActionBlock' dangerousClass="callToAction bodyText presentation" text={request_button}/>
                        
                        <TextBlock elementClass="col-12 textPadding topBorder bottomBorder" id='callToActionBlock' dangerousClass="callToAction bodyText presentation" text={text}/>
                        
                    </div>
                    
                    <FullWidthImage id="presentationsBanner" src={image} alt={image_alt_text}/>
        
                    {/*<p class="standardText">{call_to_action}</p>*/}
                    
                </div>
        
            ))}

            <Footer/>                 
            
        </div>

    )
    
}
//*******************************************************************
//*******************************************************************
export const query = graphql`
    query {
        presentations: allButterPage(filter: {slug: { eq: "presentations" } }) {
            edges {
                node {
                    slug
                    seo_title
                    page_title 
                    image
                    image_alt_text
                    introductory_text 
                    content_group {
                        section_name
                        text
                        icon
                    }  
                    text
                    call_to_action
                    call_to_action_url
                    arrow_icon
                    arrow_icon_alt_text
                    arrow_icon_url
                    form_group_1 {
                        form_field_label
                    }
                    form_group_2 {
                        form_field_label
                        dropdown_item
                    }
                    button_label
                    button_url
                    request_button
                }
            }
        }
    }
`
export default presentationsPage
//*******************************************************************
//*******************************************************************

//col-xl-10 offset-xl-1 